module.exports = __webpack_public_path__ + "img/pocketbook-CN-faq-panel.f1cf4c6.jpg";